import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather'; // Import all icons

const BroadcastReportCount = (props) => {
  const { data = [] } = props;

  // Map of type to title, color, and icon
  const typeMapping = {
    new_count: { title: 'New', color: '#2cabe3', icon: <Icon.Slash size={18} /> },
    ringing_count: { title: 'Ringing', color: '#6376ff', icon: <Icon.Rss size={18} /> },
    answer_count: { title: 'Answer', color: '#008000', icon: <Icon.PhoneForwarded size={18} /> }
  };

  // Assuming data is an array of one object, extracting the first item
  const reportData = data[0] || {};

  // Calculate total count (sum of all counts)
  const totalCount = Object.values(reportData).reduce((acc, val) => acc + parseInt(val), 0);

  return (
    <div className="report-container">
      <div className="d-flex justify-content-around align-items-center">
        {Object.keys(reportData).map((type) => {
          const { title, color, icon } = typeMapping[type];
          return (
            <div key={type} className="px-1" style={{ width: `${100 / 4}%` }}>
              <Card
                className="report-card px-2"
                style={{
                  borderBottom: `2px solid ${color}`,
                  height: '70px',
                  backgroundColor: `${color}33`
                }}>
                <div className="card-icon" style={{ backgroundColor: `${color}` }}>
                  <div className="icon mr-2 fs-5 text-white">{icon}</div>
                </div>
                <div className="d-flex flex-column ps-2">
                  <span className="fs-6">{title}</span>
                  <span className="fs-4">{reportData[type]}</span>
                </div>
              </Card>
            </div>
          );
        })}

        {/* Total Count Card */}
        <div className="px-1" style={{ width: `${100 / 4}%` }}>
          <Card
            className="report-card px-2"
            style={{
              borderBottom: `2px solid #122335`,
              height: '70px',
              backgroundColor: `#12233533`
            }}>
            <div className="card-icon" style={{ backgroundColor: `#122335` }}>
              <div className="icon mr-2 fs-5 text-white">
                <Icon.Phone size={18} />
              </div>
            </div>
            <div className="d-flex flex-column ps-2">
              <span className="fs-6">Total</span>
              <span className="fs-4">{totalCount}</span>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

BroadcastReportCount.propTypes = {
  data: PropTypes.array.isRequired
};

export default BroadcastReportCount;
